import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { EveRoutes } from '@ver-uds/e-verify';
import LoaderIcon from 'uswds/dist/img/loader.svg';
import { useAuthState } from '@vis-auth/react';
import CompanyAccess from './CompanyAccess/CompanyAccess';
import CompanyInformation from './CompanyInformation';
import CompanyLocations from './CompanyLocations';
import FullWidthLayout from '../layouts/FullWidthLayout';
import ErrorBar from './ErrorBar';
import { useAccountQuery } from '../services';
import CancelTerminationSuccessAlert from './CancelTerminationSuccessAlert/CancelTerminationSuccessAlert';

const CorporateProfile = (): JSX.Element => {
  const location = useLocation();
  const errorMessage = location.state && typeof location.state === 'string' ? String(location.state) : undefined;

  const { user } = useAuthState();
  // eslint-disable-next-line camelcase
  const accountId = user?.account_id as string;
  const { isLoading, data: accountData } = useAccountQuery(accountId);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Corporate Profile',
    });
  }, []);
  return (
    <FullWidthLayout title="My Corporate">
      {isLoading ? (
        <div className="margin-top-4 margin-bottom-3">
          Loading… <img src={LoaderIcon} alt="" className="height-2" />
        </div>
      ) : (
        <section className="padding-y-4">
          <CancelTerminationSuccessAlert />
          <h1>My Corporate Account</h1>
          <ErrorBar errorMessage={errorMessage} />
          <CompanyInformation
            isCorporateAdmin
            editUrl={EveRoutes.CORPORATE_COMPANY_INFO_EDIT}
            companyInfoData={accountData?.companyInfo}
            accountData={accountData}
          />
          <hr />
          <CompanyLocations accountData={accountData} editUrl={EveRoutes.CORPORATE_ADDRESS_EDIT} />
          <hr />
          <CompanyAccess accountData={accountData} />
        </section>
      )}
    </FullWidthLayout>
  );
};

export default CorporateProfile;
